import { DiscountDetails } from '../../model/discount-details';
import { DiscountFormData } from '../../model/discount-form-data';

export class DiscountApiMapper {
  static toDiscountFormData(api: any): DiscountFormData {
    return {
      id: api.id,
      code: api.code,
      description: api.description,
      type: api.type,
      value: api.value,
      storeIds: api.storeIds,
      validFrom: api.fromDate,
      validThrough: api.toDate,
      daysAvailable: api.daysAvailable,
      isAvailableAllDay: api.isAvailableAllDay,
      hoursAvailableStarts: api.hoursAvailableOpens
        ? DiscountApiMapper.createDateFromTimeString(api.hoursAvailableOpens)
        : null,
      hoursAvailableEnds: api.hoursAvailableCloses
        ? DiscountApiMapper.createDateFromTimeString(api.hoursAvailableCloses)
        : null,
      minimumSpend: api.minimumSpend,
      redemptionLimit: api.limitOverall,
      redemptionLimitPerCustomer: api.limitCustomer,
      isArchived: api.isArchived,
    };
  }

  static toDiscountDetails(api: any): DiscountDetails {
    return {
      id: api.id,
      code: api.code,
      createdAt: api.createdAt,
      applicableStores: api.applicableStores.map((o: any) => ({
        id: o.id,
        name: o.name,
      })),
      usageCount: api.usageCount,
      totalRedeemedAmount: api.totalRedeemedAmount,
      averageTransactionAmount: api.averageTransactionAmount,
      totalTransactionAmount: api.totalTransactionAmount,
      redeemedAmountsOverTime: api.redeemedAmountsOverTime.map((o: any) => ({
        date: new Date(o.date),
        amount: o.amount,
      })),
    };
  }

  private static createDateFromTimeString(timeString: string) {
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }
}
